export const normalizeURL = (url: string): string => {
  if (!url) return "";

  return url
    .split("/")
    .map((segment) => {
      try {
        segment = decodeURIComponent(segment);
      } catch {
        // keep original if decoding fails
      }

      return segment.trim().replace(/\s+/g, "-");
    })
    .filter(Boolean)
    .join("/")
    .replace(/\/{2,}/g, "/");
};

/**
 * Appends a CTARef parameter to a URL's query string
 * @param href - The original URL (with or without query parameters)
 * @param ctaRef - The CTA reference value to append
 * @returns The URL with the appended CTARef parameter
 */
export const appendRef = (href: string, ctaRef: string | null): string => {
  if (!href || !ctaRef) return href;

  try {
    // Use URL constructor for absolute URLs - handles all standard cases
    const url = new URL(href);
    url.searchParams.append("ctaref", ctaRef);
    return url.toString();
  } catch {
    // Handle relative URLs manually
    const hashIndex = href.indexOf("#");
    const hasFragment = hashIndex !== -1;
    const fragment = hasFragment ? href.substring(hashIndex) : "";
    const urlWithoutFragment = hasFragment
      ? href.substring(0, hashIndex)
      : href;

    const queryIndex = urlWithoutFragment.indexOf("?");
    const hasQuery = queryIndex !== -1;
    const baseUrl = hasQuery
      ? urlWithoutFragment.substring(0, queryIndex)
      : urlWithoutFragment;
    const existingQuery = hasQuery
      ? urlWithoutFragment.substring(queryIndex + 1)
      : "";

    // Encode ctaRef value (spaces as +, special chars as percent-encoded)
    const encodedCtaRef = encodeURIComponent(ctaRef).replace(/%20/g, "+");

    // Build new query string
    const newQuery = existingQuery
      ? `${existingQuery}&ctaref=${encodedCtaRef}`
      : `ctaref=${encodedCtaRef}`;

    // Standard URL format: query before fragment
    return `${baseUrl}?${newQuery}${fragment}`;
  }
};
